import { Redirect } from 'react-router-dom';
import { Layout } from 'components/Layout';
import { Route } from 'components/router/Route';
import { Switcher } from 'components/Switcher';
import { React, Suspense } from 'libs/react';
import { lazy } from 'react';
import { LocalStorage } from 'libs/storage/LocalStorage';
import { LazyLoadFallback } from 'components/loading/LazyLoadFallback';
import { QuoteScreen } from 'modules/public/quote/QuoteScreen';
import { DynamicSalesFormScreen } from 'modules/public/form/DynamicSalesFormScreen';
import { StoreScreen } from 'modules/public/store/StoreScreen';
import { StoreUpsellScreen } from 'modules/public/store/StoreUpsellScreen';
// Lazy-loaded secondary public screens
const UpdateOrganization = lazy(() => import('modules/public/forms/UpdateOrganization').then((m) => ({
    default: m.UpdateOrganization
})));
const PipeDriveComponent = lazy(() => import('modules/public/pipedrive/PipeDriveComponent').then((m) => ({
    default: m.PipeDriveComponent
})));
const OrderConfirmationDownloadScreen = lazy(() => import('modules/order/OrderConfirmationDownloadScreen').then((m) => ({
    default: m.OrderConfirmationDownloadScreen
})));
const SignupScreen = lazy(() => import('modules/public/signup/SignupScreen').then((m) => ({
    default: m.SignupScreen
})));
const DocumentationBrowseScreen = lazy(() => import('modules/public/documentation/DocumentationBrowseScreen').then((m) => ({
    default: m.DocumentationBrowseScreen
})));
const DocumentationViewScreen = lazy(() => import('modules/public/documentation/DocumentationViewScreen').then((m) => ({
    default: m.DocumentationViewScreen
})));
const OrderManufacturingApprovalScreen = lazy(() => import('modules/public/orderManufacturing/OrderManufacturingApprovalScreen').then((m) => ({
    default: m.OrderManufacturingApprovalScreen
})));
const SharedCalendarScreen = lazy(() => import('modules/public/sharedCalendar/SharedCalendarScreen').then((m) => ({
    default: m.SharedCalendarScreen
})));
const VoucherStatusScreen = lazy(() => import('modules/public/voucher/VoucherStatusScreen').then((m) => ({
    default: m.VoucherStatusScreen
})));
const PortalScreen = lazy(() => import('modules/public/portal/PortalScreen').then((m) => ({
    default: m.PortalScreen
})));
import './PublicLayout.scss';
/**
 * @component PublicLayout
 * @since 1.0.0
 */
export function PublicLayout() {
    document.documentElement.classList.toggle('dark-mode', LocalStorage.get('dark'));
    return (React.createElement(Layout, { className: "public-layout" },
        React.createElement(Suspense, { fallback: React.createElement(LazyLoadFallback, null) },
            React.createElement(Switcher, { name: "public-layout" },
                React.createElement(Route, { path: "/interactive-quote/:id/:preview?", component: QuoteScreen }),
                React.createElement(Route, { path: "/form/:lang/p/:partnerSlug", component: DynamicSalesFormScreen }),
                React.createElement(Route, { path: "/form/:lang?", component: DynamicSalesFormScreen }),
                React.createElement(Route, { path: "/store/:lang/enhance/:id", component: StoreUpsellScreen }),
                React.createElement(Route, { path: "/store/:lang/p/:partnerSlug", component: StoreScreen }),
                React.createElement(Route, { path: "/store/:lang?", component: StoreScreen }),
                React.createElement(Route, { path: "/portal/:lang?", component: PortalScreen }),
                React.createElement(Route, { path: "/pipedrive", component: PipeDriveComponent }),
                React.createElement(Route, { path: "/public/update-organization/:id", component: UpdateOrganization }),
                React.createElement(Route, { path: "/orders/confirmation/:id", component: OrderConfirmationDownloadScreen }),
                React.createElement(Route, { path: "/orders/approval/:id", component: OrderManufacturingApprovalScreen }),
                React.createElement(Route, { path: "/vouchers/status/:id?", component: VoucherStatusScreen }),
                React.createElement(Route, { path: "/signup/:lang?", component: SignupScreen }),
                React.createElement(Route, { path: "/documentation", exact: true, component: DocumentationBrowseScreen }),
                React.createElement(Route, { path: "/documentation/:id", component: DocumentationViewScreen }),
                React.createElement(Route, { path: "/shared-calendar/:token/:lang?", component: SharedCalendarScreen }),
                React.createElement(Redirect, { to: "/" })))));
}
